// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__39ie6","boxTitle":"Qualiphy_boxTitle__21Vd2","box":"Qualiphy_box__229FC","toggleWrap":"Qualiphy_toggleWrap__11R1T"};